import { useMutation } from 'react-query'
import { post, postAPI } from 'framework/api/http'

interface PWBulkOrderRetryFailedConsignmentInterface {
  serviceSplitReference?: string
  wmsOrderNo: string
}

export const useRetryFailedConsignment = () => {
  const mutate = useMutation(
    ({
      serviceSplitReference,
      wmsOrderNo,
    }: PWBulkOrderRetryFailedConsignmentInterface) => {
      return postAPI(`PWBulkConsignment/RetryFailedConsignedOrder`, {
        serviceSplitReference: serviceSplitReference,
        wmsOrderNo: wmsOrderNo,
      })
    },
  )
  return mutate
}

export default useRetryFailedConsignment
